
import Vue from 'vue';
import BlockChainUI from 'BlockChain-ui-privatization/PC/components';
import {
  Table,
  Tooltip,
  Icon,
  Pagination,
  Empty,
  FormModel,
  Input,
  Button,
  Modal,
  Tabs,
  TimePicker,
  DatePicker,
  Select,
  InputNumber,
  Spin,
} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.min.css';
import 'ant-design-vue/lib/tooltip/style/index.css';
import 'ant-design-vue/lib/table/style/index.css';
import 'ant-design-vue/lib/icon/style/index.css';
import 'ant-design-vue/lib/pagination/style/index.css';
import 'ant-design-vue/lib/empty/style/index.css';
import vuescroll from 'vuescroll/dist/vuescroll-native';
import { colorMap, getCoinShowName } from '@/utils';
import bus from '@/api/bus';
import { i18n } from '@/locale';
import App from './App.vue';
import router from '../../router/ex-router';
import store from '../../vuex/ex-index';
import axios from '../../api/http/axios';
import 'BlockChain-ui-privatization/static/css/common.styl';
import VueYoutube from 'vue-youtube';


Vue.use(VueYoutube);
window.HOSTAPI = 'ex';
Vue.use(vuescroll, {
  ops: {
    rail: {
      opacity: '1',
      background: colorMap['c-5-bd'],
      size: '4px',
      gutterOfSide: '0px',
    },
    bar: {
      background: colorMap['a-2-bg'],
      keepShow: true,
      size: '4px',
      minSize: 0.2,
    },
    scrollPanel: {
      easing: 'easeInQuad',
      speed: 800,
    },
  },
});
Vue.use(BlockChainUI);


Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.prototype.$bus = bus;

Vue.use(Table);
Vue.use(Tooltip);
Vue.use(Icon);
Vue.use(Pagination);
Vue.use(Empty);
Vue.use(FormModel);
Vue.use(Input);
Vue.use(TimePicker);
Vue.use(Button);
Vue.use(Modal);
Vue.use(Tabs);
Vue.use(Select);
Vue.use(InputNumber);
Vue.use(DatePicker);
Vue.use(Spin);


// Vue.prototype.getCoinShowName = (name) =>{
//   const coinList = this.$store.state.baseData.symbolAll;
//   if (coinList && coinList[name]) {
//     return coinList[name.toUpperCase()].showName || name;
//   }
//   return name;
// }

Vue.filter('getCoinShowName', (name, coinList) => getCoinShowName(name, coinList));

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
